import { render, staticRenderFns } from "./KeyboardNumerico.vue?vue&type=template&id=12b0f678&"
import script from "./KeyboardNumerico.vue?vue&type=script&lang=js&"
export * from "./KeyboardNumerico.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardNumerico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports